import React from "react";
const Position = ({ history }) => {
  return <div>{history.location.pathname}</div>;
  // from here i can change the language and map of the entire app
};

export default Position;
